/** @format */

import Page from "../../components/Page";
import {
  Button,
  Card,
  CircularProgress,
  Container,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import Iconify from "../../components/Iconify";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import FormControl from "@mui/material/FormControl";
// import MenuItem from "@mui/material/MenuItem";
import WAPreviewModal from "../../components/WAPreviewModal";
import MessageTemplate from "src/dao/MessageTemplate";

const headerTypeOptions = [
  { label: "Text", value: "TEXT" },
  { label: "Image", value: "IMAGE" },
  { label: "Document", value: "DOCUMENT" },
  { label: "Video", value: "VIDEO" },
];

export default function TemplateEdit() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const templateData = location.state?.templateData;

  console.log("id here", id);
  console.log("templateData", templateData);
  // const bodyRef = useRef(null);

  const [selectedButtonType, setSelectedButtonType] = useState("NONE");

  const [phoneNumberUrlArray, setPhoneNumberUrlArray] = useState([]);
  const [quickReplyArray, setQuickReplyArray] = useState([]);

  const [name, setName] = useState("");
  const [category, setCategory] = useState("Alert Update");
  const [language, setLanguage] = useState("id");
  // const [bodyChars, setBodyChars] = useState(0);
  const [content, setContent] = useState("");
  // const [footerChars, setFooterChars] = useState(0);
  const [previewIsOpen, setPreviewIsOpen] = useState(false);
  const [header, setHeader] = useState({});
  const [footer, setFooter] = useState({});
  const [buttons, setButtons] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(!templateData);

  useEffect(() => {
    if (templateData) {
      // Populate state from forwarded template data
      let headerComponent = templateData?.components?.find(
        (c) => c.type === "HEADER"
      );
      let bodyComponent = templateData?.components?.find(
        (c) => c.type === "BODY"
      );
      let footerComponent = templateData?.components?.find(
        (c) => c.type === "FOOTER"
      );
      let buttonsComponent = templateData?.components?.find(
        (c) => c.type === "BUTTONS"
      );

      if (
        buttonsComponent &&
        buttonsComponent?.buttons &&
        buttonsComponent?.buttons?.length > 0
      ) {
        setButtons(buttonsComponent.buttons);

        let sample = buttonsComponent.buttons[0];
        if (sample.type === "PHONE_NUMBER" || sample.type === "URL") {
          setPhoneNumberUrlArray(buttonsComponent.buttons);
          setSelectedButtonType("PHONE_NUMBER_URL");
        } else if (sample.type === "QUICK_REPLY") {
          setQuickReplyArray(buttonsComponent.buttons);
          setSelectedButtonType("QUICK_REPLY");
        }
      }

      setCategory(templateData.category);
      setLanguage(templateData.language);
      setContent(bodyComponent?.text || "");
      setName(templateData.name);

      if (headerComponent) {
        setHeader(headerComponent);
      }
      if (footerComponent) {
        setFooter(footerComponent);
      }

      setIsDataLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateData]);

  return (
    <Page title="View Message Template">
      <Container>
        <Stack spacing={2} direction="row" sx={{ mb: 4 }}>
          <IconButton
            sx={{ p: 0, height: "100%", backgroundColor: "white" }}
            onClick={() => navigate(-1)}
          >
            <Iconify icon="eva:arrow-ios-back-fill" width={22} height={22} />
          </IconButton>
          <Typography variant="h4">View Message Template</Typography>
        </Stack>
        {isDataLoading ? (
          <Card sx={{ p: 4 }}>
            <Stack alignItems="center">
              <CircularProgress />
            </Stack>
          </Card>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card sx={{ px: 4, py: 2 }}>
                <Stack direction="row" justifyContent="space-between">
                  <Stack direction="row" spacing={3}>
                    <Typography
                      paragraph
                      sx={{ lineHeight: "100%", margin: "auto" }}
                    >
                      {name}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={2}>
                    <Button
                      variant="outlined"
                      onClick={() => setPreviewIsOpen(true)}
                    >
                      Preview
                    </Button>
                  </Stack>
                </Stack>
              </Card>
            </Grid>
            <Grid item xs={12} md={3}>
              <Card sx={{ p: 4 }}>
                <Stack spacing={3}>
                  <Typography variant="h6">Language</Typography>
                  <FormControl>
                    <RadioGroup
                      value={language}
                      onChange={(e) => {
                        setLanguage(e.target.value);
                      }}
                      defaultValue="id"
                    >
                      <FormControlLabel
                        disabled
                        value="id"
                        control={<Radio />}
                        label="Indonesian"
                      />
                      <FormControlLabel
                        disabled
                        value="en_US"
                        control={<Radio />}
                        label="English US"
                      />
                      <FormControlLabel
                        disabled
                        value="en_GB"
                        control={<Radio />}
                        label="English GB"
                      />
                    </RadioGroup>
                  </FormControl>
                </Stack>
              </Card>
            </Grid>
            <Grid item xs={12} md={9}>
              <Stack spacing={2}>
                <Card sx={{ p: 4 }}>
                  <Stack spacing={2} direction="row">
                    <Typography variant="h6" display="inline-block">
                      Category
                    </Typography>
                    <Typography
                      paragraph
                      display="inline-block"
                      sx={{ fontSize: "1.125em" }}
                    >
                      {category}
                    </Typography>
                  </Stack>
                </Card>
                <Card sx={{ p: 4 }}>
                  <Stack spacing={1}>
                    <Stack
                      spacing={1}
                      direction="row"
                      alignItems="center"
                      sx={{ mb: 2 }}
                    >
                      <Typography variant="h6">Header</Typography>
                      <Typography variant="p" sx={{ color: "gray" }}>
                        (Optional)
                      </Typography>
                    </Stack>
                    <FormControl>
                      <RadioGroup
                        row
                        value={header === undefined ? "TEXT" : header.format}
                      >
                        {headerTypeOptions.map((obj, key) => {
                          return (
                            <FormControlLabel
                              key={key}
                              disabled
                              value={obj.value}
                              control={<Radio />}
                              label={obj.label}
                            />
                          );
                        })}
                      </RadioGroup>
                    </FormControl>
                    <Typography paragraph>
                      {header === undefined ? "(no header)" : header.text}
                    </Typography>
                  </Stack>
                </Card>
                <Card sx={{ p: 4 }}>
                  <Stack spacing={2}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="h6">Body</Typography>
                    </Stack>
                    <Stack spacing={0}>
                      <Typography paragraph sx={{ whiteSpace: "pre-line" }}>
                        {content}
                      </Typography>
                    </Stack>
                  </Stack>
                </Card>
                <Card sx={{ p: 4 }}>
                  <Stack spacing={2}>
                    <Stack
                      spacing={1}
                      direction="row"
                      alignItems="center"
                      sx={{ mb: 2 }}
                    >
                      <Typography variant="h6">Footer</Typography>
                      <Typography variant="p" sx={{ color: "gray" }}>
                        (Optional)
                      </Typography>
                    </Stack>
                    <Typography paragraph>
                      {footer === undefined ? "(no footer)" : footer.text}
                    </Typography>
                  </Stack>
                </Card>
                <Card sx={{ p: 4 }}>
                  <Stack spacing={1}>
                    <Stack
                      spacing={1}
                      direction="row"
                      alignItems="center"
                      sx={{ mb: 2 }}
                    >
                      <Typography variant="h6">Button</Typography>
                      <Typography variant="p" sx={{ color: "gray" }}>
                        (Optional)
                      </Typography>
                    </Stack>
                    <Typography paragraph>
                      {buttons && buttons.length > 0 ? (
                        <>
                          {buttons.map((obj, key) => {
                            return (
                              <>
                                <b>Type : </b>
                                {obj?.type}
                                <br />
                                <br />
                                <b>Text : </b>
                                {obj?.text}
                                <br />
                                <br />
                                {obj?.url ? (
                                  <>
                                    <b>URL : </b>
                                    {obj?.url}
                                    <br />
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}
                                {obj?.phone_number ? (
                                  <>
                                    <b>Phone Number : </b>
                                    {obj?.phone_number}
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}
                                <div style={{ height: 15 }}></div>
                                <hr
                                  style={{
                                    color: "lightGray",
                                    borderColor: "lightGray",
                                    backgroundColor: "lightGray",
                                  }}
                                />
                                <div style={{ height: 15 }}></div>
                              </>
                            );
                          })}
                        </>
                      ) : (
                        "(no button)"
                      )}
                    </Typography>
                  </Stack>
                </Card>
              </Stack>
            </Grid>
            {/*<Grid item xs={12} md={3}>*/}
            {/*  <Card sx={{p: 4}}>*/}
            {/*    <Typography variant="h6">Preview</Typography>*/}
            {/*  </Card>*/}
            {/*</Grid>*/}
          </Grid>
        )}
      </Container>

      <WAPreviewModal
        headerFormat={header.format}
        header={header.format === "TEXT" ? header.text : null}
        footer={footer.text}
        buttonType={selectedButtonType}
        buttonQuickReply={quickReplyArray}
        buttonPhoneNumberURL={phoneNumberUrlArray}
        content={content}
        open={previewIsOpen}
        setOpen={setPreviewIsOpen}
        isPreview
      />
    </Page>
  );
}
